/* eslint-disable react/jsx-no-bind */
// @flow
import * as React from 'react';
import { Box, Stack, NumberField } from '@locus-taxy/neo-ui';

import {
    rankWith,
    uiTypeIs,
    or,
    isNumberControl,
    isIntegerControl
} from '@jsonforms/core';
import MaraOnlyTag from '../components/MaraOnlyTag';
import useControlProps from '../util/useControlProps';

export const NumberFieldControl = (props: Props): React.Node => {
    const {
        schema,
        path,
        data,
        handleChange,
        visible,
        required,
        enabled,
        errors,
        label,
        description,
        uischema: { options }
    } = useControlProps(props);

    const { isMaraOnlyField } = options || {};

    return (
        visible && (
            <Stack>
                <Box>
                    <NumberField
                        label={label}
                        value={data ?? ''}
                        fullWidth
                        required={required}
                        error={errors}
                        disabled={!enabled}
                        min={schema.minimum}
                        max={schema.maximum}
                        helperText={errors ? errors : description}
                        onChange={value => {
                            handleChange(
                                path,
                                typeof value === 'number' ? value : undefined
                            );
                        }}
                    />
                </Box>
                {isMaraOnlyField && (
                    <Box py="1">
                        <MaraOnlyTag />
                    </Box>
                )}
            </Stack>
        )
    );
};

export default NumberFieldControl;

export const numberFieldControlTester = rankWith(
    1,
    or(uiTypeIs('NumberFieldControl'), isNumberControl, isIntegerControl)
);
